export default "__VITE_ASSET__B$XAq$Vq__"